import React from 'react';
import { terms } from '../../../../../dashboard/constants';

export const NoNewActivitiesMessage = () => {
    return (
        <div className="d-flex flex-column justify-content-center align-items-center text-center">
            <h3 className="helix-body--strong mb-2">{terms.noNewActivity}</h3>
            <p className="helix-text-gray-500 mb-0">{terms.noNewActivityMessage}</p>
        </div>
    );
};
